module.exports = __webpack_public_path__ + "static/media/WorkoutSignupM.1709ddda.png";